<template>
  <section class="views">
    <!-- header -->
    <!-- <headers select="-1"></headers> -->

    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="require('@/assets/image/hodgepodge/pcbanner.jpg')"
      />
      <div class="posters_ewm">
        <div class="ewm" @click="whatapp()">
          <div class="ewm2">
            <div class="ewm3">
              <img :src="require('@/assets/image/hodgepodge/ewm.png')" alt="" />
            </div>
            <div class="ewm3_value">
              <img :src="require('@/assets/image/wa.png')" alt="" /> 人工諮詢
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- from -->
    <div class="content" v-if="step === 1">
      <div class="contentFrom_titleBox">
        <!-- <div class="contentFrom_title">參賽方式</div> -->
        <div class="contentFrom_title">新增学生</div>
        <!-- 報名資料 -->
      </div>
      <div class="contentFrom_uls">
        <ul>
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">參賽者姓名</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入參賽者姓名"
                    v-model.trim="from.studentName"
                  />
                </div>
              </div>
              <!-- <div class="beizhu">*須與身份證上的姓名一致</div> -->
            </div>
          </li>
          <li>
            <div class="list">
              <div class="listLeft">性别</div>
              <div class="listRight">
                <!-- @click="sexBut" -->
                <div class="listRight_xuan">
                  <van-popover
                    v-model="showSexPopover"
                    trigger="click"
                    :actions="sexActions"
                    @select="onSexSelect"
                  >
                    <template #reference>
                      <div
                        class="promptInputValue"
                        :class="sexIndex == -1 ? '' : 'placeholderValue'"
                      >
                        {{ from.gender }}
                      </div>
                    </template>
                  </van-popover>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">年級</div>
                <div class="listRight">
                  <div class="listRight_xuan">
                    <van-popover
                      v-model="showGradePopover"
                      placement="right"
                      trigger="click"
                      :actions="gradeActions"
                      @select="onGradeSelect"
                    >
                      <template #reference>
                        <div
                          class="promptInputValue"
                          :class="gradeIndex == -1 ? '' : 'placeholderValue'"
                        >
                          {{ from.grade }}
                        </div>
                      </template>
                    </van-popover>
                  </div>
                </div>
              </div>

              <!-- <div class="beizhu">*選擇後即代表報名對應參賽組別</div> -->
            </div>
          </li>
          <li>
            <div class="list">
              <div class="listLeft">非華裔</div>
              <div class="listRight">
                <div class="listRight_xuan">
                  <van-popover
                    v-model="showNonChinesePopover"
                    trigger="click"
                    :actions="nonChineseActions"
                    @select="onNonChineseSelect"
                  >
                    <template #reference>
                      <div
                        class="promptInputValue"
                        :class="nonChineseIndex == -1 ? '' : 'placeholderValue'"
                      >
                        {{ from.nonChinese }}
                      </div>
                    </template>
                  </van-popover>
                </div>
              </div>
            </div>
          </li>
          <!-- 登入账号 -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">登入賬號</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入登入賬號（不可輸入漢字）"
                    v-model.trim="from.studentNo"
                    @input="onLoginAccountInput"
                  />
                </div>
              </div>
            </div>
          </li>
          <!-- 登入密码 -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">登入密碼</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入登入密碼（不可輸入漢字）"
                    v-model.trim="from.password"
                    @input="onLoginPasswordInput"
                  />
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">電話號碼</div>
                <div class="listRight">
                  <div class="listRight_sji">
                    <div class="left" style="cursor: pointer">
                      <van-popover
                        v-model="mobilePhoneActionsShow"
                        placement="bottom"
                        trigger="click"
                        :actions="mobilePhoneActions"
                        @select="onmobilePhoneSelect"
                      >
                        <template #reference>
                          <div
                            class="promptInputValue"
                            :class="mobilePhoneIndex == -1 ? '' : 'placeholderValue'"
                          >
                            {{ from.prefix }}
                            <span
                              :class="{ '': true, left_formTwo: showPickerTwo }"
                            >
                              <van-icon
                                name="arrow-down"
                                size="12"
                                color="#333333"
                              />
                            </span>
                          </div>
                        </template>
                      </van-popover>
                    </div>

                    <div class="right">
                      <input
                        type="number"
                        placeholder="請輸入手機號碼"
                        v-model.trim="from.phone"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <template>
            <!-- 验证码 -->
            <!-- <li>
              <div class="list">
                <div class="listLeft">手機驗證碼</div>
                <div class="listRight">
                  <div class="listRight_sji2">
                    <div class="right">
                      <input
                        type="text"
                        placeholder="請輸入驗證碼"
                        v-model.trim="from.verifyCode"
                      />
                    </div>
                    <div
                      class="right2"
                      @click="CodeBln ? clickNumberCodeFnc() : ''"
                      v-html="codeMsg"
                    ></div>
                  </div>
                </div>
              </div>
            </li> -->

            <li>
              <div class="list">
                <div class="listLeft">電郵</div>
                <div class="listRight" style="display: flex">
                  <input
                    type="text"
                    placeholder="請輸入參賽者電郵"
                    v-model.trim="from.email"
                  />
                </div>
              </div>
            </li>
          </template>
          <li>
            <div class="list">
              <div class="listLeft">學校名稱</div>
              <div class="listRight listPan" style="display: flex">
                <input
                  type="text"
                  v-model.trim="from.schoolName"
                  disabled
                  style="color:#999;cursor:not-allowed;border:none"
                />
              </div>
            </div>
          </li>
        </ul>
        <!-- <div class="uls_beizhu">
          * 如學校/機構 進行統一報名參賽，請切換到【學校報名】<br />*
          特殊學校-閃亮組、非華裔-飛躍組
          請通過學校老師進行統一報名，請老師切換到【學校報名】
        </div> -->
      </div>

      <div class="fromButtom">
        <button class="btn btn-cancel" @click="handleCancel">取消</button>
        <button class="btn btn-confirm" @click="handleSubmit">確認新增</button>
      </div>
      <!-- <div class="timeUp"><div>報名已結束</div></div> -->
    </div>

    <!-- 新增成功頁 -->
    <div class="success_view" v-else>
      <div class="success_header">
        <van-icon name="passed" size="24" color="#ffffff" />
        <span>註冊成功</span>
      </div>

      <div class="success_card">
        <div class="success_title_block">
          <p class="title">APP下載</p>
          <img src="@/assets/image/app_chineserd.png" alt="" />
          <button class="btn btn-download" @click="handleDownloadApp">
            點擊下載
          </button>
        </div>

        <div class="info_box">
          <div class="info_item">請下載APP進行登入，你的登入信息如下</div>
          <div class="info_item">學校編號：{{ schoolCode }}</div>
          <div class="info_item">登入賬號為：{{ studentNo }}</div>
        </div>
      </div>
    </div>

    <!-- 展位 -->
    <div style="width: 100%"></div>

    <!-- 性别 -->
    <van-popup
      v-model="showPicker"
      position="bottom"
      :style="{
        'min-height': '30%',
        'max-width': '944px',
        margin: 'auto',
        right: '0',
        left: '0',
      }"
    >
      <van-picker
        show-toolbar
        :columns="sexColumns"
        @confirm="onSexConfirm"
        @cancel="showPicker = false"
        confirm-button-text="確認"
      />
    </van-popup>
    <!-- code -->
    <van-popup
      v-model="showPickerTwo"
      position="bottom"
      :style="{
        'min-height': '30%',
        'max-width': '944px',
        margin: 'auto',
        right: '0',
        left: '0',
      }"
    >
      <van-picker
        show-toolbar
        :columns="mobilePhoneColumns"
        @confirm="onPhoneConfirm"
        @cancel="showPickerTwo = false"
        confirm-button-text="確認"
      />
    </van-popup>
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
import selectBox from "./components/select";
import publics from "@/mixin/public_mixin";
import home from "@/mixin/home_mixin";
export default {
  name: "addStudent",
  data() {
    return {
      step: 1,
      showSexPopover: false,
      sexActions: [
        {
          text: "男",
          id: 0,
        },
        {
          text: "女",
          id: 1,
        },
      ],
      sexIndex: -1,
      showGradePopover: false,
      gradeActions: [
        { text: "K1", id: 0 },
        { text: "K2", id: 1 },
        { text: "K3", id: 2 },
        { text: "P1", id: 3 },
        { text: "P2", id: 4 },
        { text: "P3", id: 5 },
        { text: "P4", id: 6 },
        { text: "P5", id: 7 },
        { text: "P6", id: 8 },
        { text: "S1", id: 9 },
        { text: "S2", id: 10 },
        { text: "S3", id: 11 },
        { text: "S4", id: 12 },
        { text: "S5", id: 13 },
        { text: "S6", id: 14 },
      ],
      gradeIndex: -1,
      mobilePhoneIndex: -1,
      // 非華裔选择
      showNonChinesePopover: false,
      nonChineseActions: [
        { text: "是", id: 1 },
        { text: "否", id: 0 },
      ],
      nonChineseIndex: -1,

      dqiSelectIndex: -1, //默認0
      dqiSelectIndex2: -1, //默認不選擇

      mobilePhoneActionsShow: false,
      mobilePhoneActions: [
        {
          text: "+852",
          id: 0,
        },
        {
          text: "+86",
          id: 1,
        },
      ],
      from: {
        studentName: "",
        gender: "請選擇參賽者性别", //-1 未选中  0男  1女
        nonChinese: "請選擇是否非華裔",
        studentNo: "",
        password: "",
        prefix: "+852", //区号
        phone: "", //手机号
        // verifyCode: "", //手机验证码
        grade: "選擇參賽者年級", //年级
        email: "", //邮件
        schoolName: "", //就读学校
      },
      showPicker: false,
      showPickerTwo: false,
      sexColumns: ["請選擇參賽者性别", "男", "女"],
      mobilePhoneColumns: ["+852", "+86"], //区号

      CodeBln: true,
      codeMsg: "獲取驗證碼",
      schoolId: null,
      schoolCode: "",
      studentNo: "",
    };
  },
  computed: {},
  mixins: [publics, home],
  components: {
    headers,
    selectBox,
  },
  created() {},
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const schoolId = urlParams.get("id");
    const schoolCode = urlParams.get("schoolCode");
    const schoolName = urlParams.get("schoolName");
    if (!schoolId) {
      this.$toast && this.$toast.fail("缺少學校編號參數");
      return;
    }
    this.$nextTick(()=>{
      this.from.schoolName = schoolName || "";
      this.schoolId = schoolId || "";
      this.schoolCode = schoolCode || "";
    })
  },
  methods: {
    handleCancel() {
      // 转到首页
      this.$router.push({ path: "/" });
    },
    whatapp() {
      this.home_mdevInit();
      window.open(this.whatUrl, "_blank");
    },
    onmobilePhoneSelect(action) {
      this.mobilePhoneIndex = action.id;
      this.from.prefix = action.text;
    },
    // 電郵驗證
    validator_email(val) {
      const email = val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    onSexSelect(action) {
      this.sexIndex = action.id;
      this.from.gender = action.text;
    },
    onGradeSelect(action) {
      this.gradeIndex = action.id;
      this.from.grade = action.text;
    },
    onNonChineseSelect(action) {
      this.nonChineseIndex = action.id;
      this.from.nonChinese = action.text;
    },
    // 登入賬號/密碼：禁止輸入漢字，允許大小寫字母、符號、數字
    onLoginAccountInput(e) {
      const val = String(e.target.value);
      // 去除所有 CJK（中文）字符
        const sanitized = val.replace(/[\p{Script=Han}\s]/gu, "");
      this.from.studentNo = sanitized;
    },
    onLoginPasswordInput(e) {
      const val = String(e.target.value);
        const sanitized = val.replace(/[\p{Script=Han}\s]/gu, "");
      this.from.password = sanitized;
    },
    validator_phone(val) {
      const phone = val;
      return /^[0-9]*$/.test(phone);
    },
    // 验证码
    clickNumberCodeFnc() {
      let { prefix, phone } = this.from;
      if (phone == null || phone == "") {
        this.$toast.fail("請檢查您的手機號");
        return;
      }

      if (!this.validator_phone(phone)) {
        this.$toast("手機號格式有誤 !");
        return;
      }
      const phoneList = [];
      phoneList.push(prefix + "-" + phone);
      const params = {
        appType: 12,
        verifyType: 9,
        phoneList,
        smsTemplateType: 10,
        signType: 1,
      };

      this.$toast.loading({
        message: "正在獲取中...",
        forbidClick: true,
        duration: 0,
      });
      let sendUrl = this.$api.sendSmsForSecondCup;

      this.$axios({
        url: sendUrl,
        method: "post",
        data: params,
      })
        .then((response) => {
          console.log("response", response);
          if (response.data.code == 0) {
            this.$toast.clear();
            this.$toast.success("驗證碼获取成功");
            let that = this;
            clearInterval(that.timeIntinvel);
            that.CodeBln = false;
            let index = 60;

            that.timeIntinvel = setInterval(() => {
              index--;
              if (index <= 0) {
                index = 0;
                that.CodeBln = true;
                that.codeMsg = "獲取驗證碼";
              } else {
                that.codeMsg = `${index}S`;
              }
            }, 1000);
          } else {
            this.$toast.fail("驗證碼获取失败");
          }
        })
        .catch((error) => {
          //请求失败
          this.$toast.clear();
          this.$toast.fail("error");
          console.log(error);
        });
    },
    // 表单提交
    handleSubmit() {
      const {
        prefix,
        phone,
        studentName,
        email,
        grade,
        gender,
        nonChinese,
        password,
        studentNo,
      } = this.from;
      if (studentName == "" || studentName == null) {
        this.$toast.fail("請檢查參賽者姓名");
        return;
      }

      if (gender == "請選擇參賽者性别" || gender == null) {
        this.$toast.fail("請選擇參賽者性别");
        return;
      }

      if (grade == "選擇參賽者年級" || grade == null) {
        this.$toast.fail("選擇參賽者年級");
        return;
      }
      if (nonChinese == "請選擇是否非華裔" || nonChinese == null) {
        this.$toast.fail("請選擇是否非華裔");
        return;
      }
      console.log(studentNo,password);
      
      if (!studentNo) {
        this.$toast.fail("請輸入登入賬號");
        return;
      }
      if (!password) {
        this.$toast.fail("請輸入登錄密碼");
        return;
      }
      if (phone == "" || phone == null) {
        this.$toast.fail("請輸入參賽者電話");
        return;
      }

      if (!this.validator_phone(phone)) {
        this.$toast("手機號格式有誤 !");
        return;
      }
      // if (verifyCode == "" || verifyCode == null) {
      //   this.$toast.fail("請輸入驗證碼");
      //   return;
      // }
      if (email == "" || email == null) {
        this.$toast.fail("請輸入電郵");
        return;
      }
      if (!this.validator_email(email)) {
        this.$toast("電郵格式有誤 !");
        return;
      }

      // if (schoolName == "" || schoolName == null) {
      //   this.$toast.fail("請檢查就讀學校");
      //   return;
      // }
      
      const params = {
        studentName,
        gender,
        prefix,
        phone,
        grade,
        nonChinese: nonChinese == "是" ? 1 : 0,
        prefix: prefix.replace(/\+/g, ""),
        email,
        // verifyCode,
        studentNo,
        password,
        schoolId: this.schoolId,
        platform: !localStorage.getItem("c") ? "PC" : localStorage.getItem("c"),
      };
      console.log("提交", params);
      this.$toast.loading({
        message: "正在提交中...",
        forbidClick: true,
        duration: 0,
      });
      this.$axios
        .post(this.$api.addStudent, params).then((response) => {
          // console.log(response)
          if (response.data.code == 0) {
            this.studentNo = studentNo;
            this.step = 2;
            // 取消toast
            this.$toast.clear();
          } else {
            this.$toast.fail(response.data.msg);
          }
        })
        .catch((error) => {
          //请求失败
          this.$toast.clear();
          this.$toast.fail("error");
          console.log(error);
        });
    },
    onSexConfirm(e) {
      console.log(e);
      this.from.gender = e;
      this.showPicker = false;
    },
    sexBut() {
      this.showPicker = true;
    },
    pickerPhoneBut() {
      this.showPickerTwo = true;
    },
    onPhoneConfirm(e) {
      console.log(e);
      this.from.prefix = e;
      this.showPickerTwo = false;
    },
    // APP 下載
    handleDownloadApp() {
      const url = "https://app.chineserd.com/";
      // 打开新窗口
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;

  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      right: 20px;
      bottom: 20px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: right;

      .ewm {
        width: 161px;
        min-height: 189px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 8px;
        box-sizing: border-box;
        cursor: pointer;

        .ewm2 {
          width: 100%;
          height: 100%;
          padding: 6px;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;

          .ewm3 {
            width: 132px;
            height: 132px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            width: 100%;
            height: 40px;
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            background: url("~@/assets/image/icon/ewmbut.png") no-repeat;
            background-size: 100% 100%;
            box-shadow: inset 0px 1px 4px 0px rgba(234, 138, 7, 0.48),
              inset 0px -5px 3px 0px rgba(255, 227, 129, 0.57);
            vertical-align: middle; /* 将文本和图片垂直居中对齐 */

            img {
              width: 20px;
              height: 20px;
              margin-right: 4px;
              vertical-align: middle; /* 将图片和文本垂直居中对齐 */
            }
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    max-width: 944px;
    margin: auto;
    margin-top: 83px;
    margin-bottom: 30px;

    // min-height: 795px;
    background: #ffffff;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 16px;

    padding-bottom: 26px;

    .contentFrom_titleBox {
      width: 100%;
      height: 52px;
      position: relative;

      .contentFrom_title {
        width: 265px;
        height: 52px;
        margin: auto;
        border-radius: 9px;
        background: url("~@/assets/image/icon/titlebg.png") no-repeat;
        background-size: 100% 100%;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 23px;
        line-height: 52px;
        position: absolute;
        top: -47%;
        left: 0;
        right: 0;
        margin: auto;

        text-shadow: 1.5px 1.5px 0 #ff782f, -1.5px 1.5px 0 #ff782f,
          1.5px -1.5px 0 #ff782f, -1.5px -1.5px 0 #ff782f;
      }
    }

    .listRight_sji {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      text-align: right;
      justify-content: flex-end;
      color: #cccccc;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;

      .left {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        padding-right: 0.32rem;
        box-sizing: border-box;

        span:nth-child(1) {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-right: 10px;
        }

        .left_formTwo {
          transform: rotate(180deg);
        }
      }

      .left:after {
        content: " ";
        width: 1px;
        height: 20px;
        background: #cccccc;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }

      .right {
        padding-left: 30px;
        box-sizing: border-box;
        width: 150px;
        height: 100%;
      }
    }

    .contentFrom_uls {
      padding: 30px 158px 0 158px;
      box-sizing: border-box;

      ul {
        width: 100%;
        background: #ffffff;

        li:last-child {
          border-bottom: none !important;
        }

        li {
          width: 100%;
          border-bottom: 1px solid #f2f2f2;
          .list {
            width: 100%;
            height: 68px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .listLeft {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .listPan {
              position: relative;
            }

            .listRight {
              width: 70%;
              height: 100%;
              position: relative;

              input {
                width: 100%;
                height: 100%;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                border: none;
                text-align: right;
                background: none;
                padding: 0;
                box-sizing: border-box;
              }
              /* 隐藏步进器 */
              input[type="number"]::-webkit-inner-spin-button,
              input[type="number"]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }

              input[type="number"] {
                appearance: none;
                -moz-appearance: textfield; /* Firefox */
              }

              input::-webkit-input-placeholder {
                color: #cccccc;
              }

              /* 使用webkit内核的浏览器 */
              input:-moz-placeholder {
                color: #cccccc;
              }

              /* Firefox版本4-18 */
              input::-moz-placeholder {
                color: #cccccc;
              }

              /* Firefox版本19+ */
              input:-ms-input-placeholder {
                color: #cccccc;
              }

              /* IE浏览器 */

              .listRight_xuan {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                cursor: pointer;

                .placeholderValue {
                  color: #000000 !important;
                }

                .listRight_icon {
                  margin-left: 10px;
                }

                .listRight_icontransform {
                  transform: rotate(180deg);
                }
              }
              .listRight_xuan_2 {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                cursor: pointer;

                .placeholderValue {
                  color: #000000 !important;
                  // 鼠标变为不可点击
                  cursor: not-allowed;
                }

                .listRight_icon {
                  margin-left: 10px;
                }

                .listRight_icontransform {
                  transform: rotate(180deg);
                }
              }

              .listRight_sji2 {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;

                .right {
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  position: relative;
                  padding-right: 30px;
                  box-sizing: border-box;
                }

                .right2 {
                  font-size: 14px;
                  font-family: PingFang SC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: #52a1ff;
                  display: flex;
                  align-items: right;
                  width: 79px;
                  justify-content: right;
                  cursor: pointer;
                }

                .right:after {
                  content: " ";
                  width: 1px;
                  height: 20px;
                  background: #cccccc;
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                }
              }

              .selectBox {
                position: absolute;
                top: 100%;
                right: 0;
                min-width: 200px;
                min-height: 20px;
                background: #ffffff;
                z-index: 99;
                padding: 10px;
                border-radius: 10px;
                box-shadow: 0 2px 12px rgba(50, 50, 51, 0.12);
                display: flex;

                .selectBoxLeft {
                  width: 49%;
                  min-height: 30px;

                  .selectBox_uls {
                    width: 100%;
                    height: 100%;
                    overflow-y: hidden;
                    font-size: 14px;

                    .selectBox_lis {
                      width: 100%;
                      height: 30px;
                      display: flex;
                      align-items: center;
                      white-space: nowrap;
                    }
                  }
                }

                .selectBox_xian {
                  width: 1px;
                  background: #cccccc;
                  border-radius: 10px;
                }

                .selectBoxRight {
                  width: 49%;
                  min-height: 30px;
                  max-height: 300px;
                  margin-left: 10px;

                  .selectBox_uls {
                    width: 100%;
                    height: 100%;
                    font-size: 14px;
                    overflow-y: hidden;

                    .selectBox_lis {
                      width: 100%;
                      height: 30px;
                      display: flex;
                      align-items: center;
                      white-space: nowrap;
                    }
                  }
                }

                .selectBox_lis {
                  cursor: pointer;
                }

                .select_select {
                  color: red;
                }
              }
            }
            .beizhu {
              width: 100%;
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #e80202;
              margin-top: 8px;
              text-align: left;
              padding-bottom: 9px;
              box-sizing: border-box;
              margin-top: -10px;
            }
          }

          .list2 {
            width: 100%;

            .list2_uls {
              width: 100%;
              height: 68px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .listLeft {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .listRight {
                width: 70%;
                height: 100%;
                display: flex;

                input {
                  width: 100%;
                  height: 100%;
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #000000;
                  border: none;
                  text-align: right;
                  background: none;
                  padding: 0;
                  box-sizing: border-box;
                }

                /* 隐藏步进器 */
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                  -webkit-appearance: none;
                  margin: 0;
                }

                input[type="number"] {
                  appearance: none;
                  -moz-appearance: textfield; /* Firefox */
                }

                input::-webkit-input-placeholder {
                  color: #cccccc;
                }

                /* 使用webkit内核的浏览器 */
                input:-moz-placeholder {
                  color: #cccccc;
                }

                /* Firefox版本4-18 */
                input::-moz-placeholder {
                  color: #cccccc;
                }

                /* Firefox版本19+ */
                input:-ms-input-placeholder {
                  color: #cccccc;
                }

                /* IE浏览器 */

                .listRight_xuan {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  text-align: right;
                  justify-content: flex-end;
                  color: #cccccc;
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  cursor: pointer;

                  .placeholderValue {
                    color: #000000 !important;
                  }

                  .listRight_icon {
                    margin-left: 10px;
                  }

                  .listRight_icontransform {
                    transform: rotate(180deg);
                  }
                }
              }
            }

            .beizhu {
              width: 100%;
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #e80202;
              margin-top: 8px;
              text-align: left;
              padding-bottom: 9px;
              box-sizing: border-box;
              margin-top: -10px;
            }
          }
        }
      }

      .uls_beizhu {
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #e80202;
        line-height: 18px;
        text-align: left;
      }
    }

    .promptInputValue {
      min-width: 100px;
      height: 68px;
      line-height: 68px;
      // padding-left: 13px;
      // box-sizing: border-box;
      // border: none;
      // background: #f5f5f5;
      // border-radius: 6px 6px 6px 6px;
      // font-size: 12px;
      // font-family: PingFang SC-Regular, PingFang SC;
    }

    .fromButtom {
      width: 360px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin: 0 auto;
      margin-top: 32px;

      .btn {
        flex: 1;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 25px;
        border: none;
        cursor: pointer;
        letter-spacing: 2px;
        transition: all 0.2s ease;
      }

      .btn-cancel {
        color: #ff782f;
        background: #fff3ec;
        box-shadow: 0 4px 9px rgba(255, 120, 47, 0.15) inset;
      }
      .btn-cancel:hover {
        background: #ffe6d9;
      }

      .btn-confirm {
        color: #ffffff;
        background: rgb(255, 120, 47);
        box-shadow: 0px 4px 9px 0px rgba(255, 120, 47, 0.4);
      }
      .btn-confirm:hover {
        opacity: 0.92;
      }
    }
    .last-step {
      margin: 20px 0;
      font-size: 14px;
      letter-spacing: 2px;
      color: rgb(255, 120, 47);
      span {
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .timeUp {
      width: 300px;
      height: 48px;
      margin: auto;
      margin-top: 32px;
      background: #d0d0d0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      cursor: not-allowed;
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 20px;
      box-shadow: 0px 4px 9px 0px rgba(208, 208, 208, 0.4);
      border-radius: 24px;
    }
  }
}

.views::-webkit-scrollbar {
  display: none;
}

/* PC 端適配的成功頁樣式（對齊 H5 結構，但以 PC 視覺與尺寸重構）*/
.success_view {
  width: 100%;
  max-width: 500px;
  min-height: calc(100vh - 64px);
  padding: 40px 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  .success_header {
    display: flex;
    align-items: center;
    color: #ffffff;
    font-size: 20px;
    margin-bottom: 24px;

    span {
      margin-left: 8px;
    }
  }

  .success_card {
    width: 100%;
    max-width: 944px; /* 與 PC 表單內容對齊 */
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 20px 32px;
    box-sizing: border-box;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    overflow: hidden;

    .success_title_block {
      text-align: center;
      margin-bottom: 20px;

      .title {
        font-size: 22px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 8px;
      }

      img {
        width: 100%;
        max-width: 280px;
        height: auto;
        border-radius: 12px;
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
        margin: 16px auto 20px;
        display: block;
      }

      .btn-download {
        width: 100%;
        max-width: 360px;
        height: 44px;
        border-radius: 22px;
        border: none;
        background: linear-gradient(90deg, #ff9a2b 0%, #ff6b00 100%);
        color: #ffffff;
        font-size: 18px;
        font-weight: 600;
        box-shadow: 0px 4px 9px 0px rgba(255, 107, 0, 0.45);
        margin: 0 auto;
        display: block;
        cursor: pointer;
      }
      .btn-download:hover {
        opacity: 0.95;
      }
    }

    .info_box {
      width: 100%;
      background: #fff7ec;
      border-radius: 12px;
      padding: 20px 16px;
      box-sizing: border-box;
      border: 1px solid #ffd9b3; /* 保留 px 精度 */

      .info_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        color: #333333;
        line-height: 22px;

        & + .info_item {
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
